import { ko } from './ko/common';
import { en } from './en/common';

export default {
  ko: {
    translation: ko,
  },
  en: {
    translation: en,
  },
};
